<template>
  <ul class="tabBar">
    <router-link class="tab-item" tag="li" v-for="(link, index) in tabs" :key="'tab' + index" :to="link.path">
      <i class="icon" :style="{backgroundImage: `url(${link.icon})`}"></i><span class="f-s13">{{link.title}}</span>
    </router-link>
  </ul>
</template>

<script>
  import a from './images/a.png';
  import b from './images/b.png';
  import c from './images/c.png';
  export default {
    name: "tab-bar",
    props: {
      tabs: {
        type: Array,
        default () {
          return [
            {
              path: '/home/user',
              icon: a,
              title: '个人中心',
            },
            {
              path: '/home/settled',
              icon: b,
              title: '今日已结',
            },
            {
              path: '/home/history',
              icon: c,
              title: '账户历史',
            }
          ]
        }
      }
    }
  }
</script>

<style scoped lang="less">
  .tabBar{
    display: flex;
    font-size: 26px;
    flex-wrap: wrap;
    border-top: 1px solid #dcdcdc;
    align-items: center;
    border-bottom: 1px solid #dcdcdc;
    justify-content: space-around;
    background-color: #fff;

    .tab-item{
      width: 33.333%;
      height: 90px;
      display: flex;
      box-sizing: border-box;
      align-items: center;
      justify-content: center;
      >i{
        width: 36px;
        height: 36px;
        margin-right: 10px;
        border-right: 50px;
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center center;
      }
    }
    .tab-item~.tab-item{
      border-left: 1px solid #d2d2d2;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/tab-bar/index.vue